import * as React from 'react';

interface HeaderTitleProps {
	title?: string;
}

export const HeaderTitle: React.FC<HeaderTitleProps> = ({ title }) => {
	// Use provided title or fallback to hardcoded text
	const displayTitle = title || "If you don't speak, \nhow will they know?";

	// Split by line breaks to maintain formatting
	const titleLines = displayTitle.split('\n');

	return (
		<h1 className='text-6xl max-md:max-w-full max-md:text-4xl max-md:leading-10 w-3xl'>
			{titleLines.map((line, index) => (
				<React.Fragment key={index}>
					{line}
					{index < titleLines.length - 1 && <br />}
				</React.Fragment>
			))}
			{!displayTitle.endsWith('?') && <span className='text-white'>?</span>}
		</h1>
	);
};
